import React from 'react'
import { Col, Row } from 'antd'
import { InfoList } from './MyProfilePageStyled'
import { inject, observer } from 'mobx-react'
import { EmptyText } from '../../components/Common/CellText'

const Education = props => {
  const { authenticationStore } = props

  const { currentUser } = authenticationStore
  const nullText = <EmptyText>Chưa cập nhật</EmptyText>

  return (
    <Row gutter={[20, 10]}>
      <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
        <InfoList dtWidth={'240px'}>
          <dt>Trình độ giáo dục phổ thông</dt>
          <dd>{currentUser?.other?.education_level || nullText}</dd>
          <dt>Trình độ chuyên môn cao nhất</dt>
          <dd>{currentUser?.other?.qualification || nullText}</dd>
          <dt>Lý luận chính trị</dt>
          <dd>{currentUser?.other?.political_theory || nullText}</dd>
          <dt>Tin học</dt>
          <dd>{currentUser?.other?.IT || nullText}</dd>
          <dt>Ngoại ngữ</dt>
          <dd>{currentUser?.other?.foreign_language || nullText}</dd>
          <dt>Quản lý nhà nước</dt>
          <dd>{currentUser?.other?.state_management || nullText}</dd>
          <dt>Khen thưởng</dt>
          <dd>{currentUser?.other?.laudatory || nullText}</dd>
          <dt>Kỷ luật</dt>
          <dd>{currentUser?.other?.discipline || nullText}</dd>
        </InfoList>
      </Col>
      <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
        <InfoList dtWidth={'240px'}>
          <dt>Ngày vào Đảng Cộng sản Việt Nam</dt>
          <dd>{currentUser?.other?.join_date || nullText}</dd>
          <dt>Ngày chính thức</dt>
          <dd>{currentUser?.other?.official_date || nullText}</dd>
          <dt>Ngày tham gia tổ chức chính trị xã hội</dt>
          <dd>{currentUser?.other?.join_political || nullText}</dd>
          <dt>Ngày nhập ngũ</dt>
          <dd>{currentUser?.other?.date_of_enlistment || nullText}</dd>
          <dt>Ngày xuất ngũ</dt>
          <dd>{currentUser?.other?.demobilization_date || nullText}</dd>
          <dt>Quân hàm cao nhất</dt>
          <dd>{currentUser?.other?.army_rank || nullText}</dd>
          <dt>Sở trường công tác</dt>
          <dd>{currentUser?.other?.forte || nullText}</dd>
          <dt>Danh hiệu được phong tặng cao nhất</dt>
          <dd>{currentUser?.other?.title || nullText}</dd>
        </InfoList>
      </Col>
    </Row>
  )
}

Education.propTypes = {}

export default inject('authenticationStore')(observer(Education))
